<template>
    <div>
        <v-alert dense outlined type="error" v-if="alertError">
            No fue posible la comunicación con <strong>API SERVICE</strong> ponganse en contacto con el administrador si este mensaje persiste.
        </v-alert>            
        
        <v-toolbar title elevation="1">
            <v-toolbar-title class="tituloMaquinaria">{{TituloTabla}}</v-toolbar-title>
            <v-divider vertical class="ml-3"></v-divider>    

            <v-spacer></v-spacer>      
            <v-text-field outlined class=" pr-4"
                label="Buscar Registro"
                v-model="buscarRegistro"
                append-icon="mdi-magnify"
                single-line
                hide-details
            ></v-text-field>
            <v-tooltip bottom color="#0019d8" >
                <template v-slot:activator="{ on }">
                        <v-btn color="#0019d8" rounded dark @click="ObtenerInventarioHerramientaPorSucursal()"
                            v-on="on" class="TamañoLetraBoton mx-2" :disabled="!ActivarMenuTabs"
                        > 
                            <v-icon >fas fa-sync-alt</v-icon> 
                        </v-btn>
                </template>
                <span>Actualizar Tabla</span>
            </v-tooltip>                                       
            <v-tooltip bottom color="error" >
                <template v-slot:activator="{ on }">
                        <v-btn color="error" rounded dark @click="AbrirModalVisualizarPDFInventario()"
                            v-on="on" class="TamañoLetraBoton mx-2" :disabled="!ActivarMenuTabs"
                        > 
                            <v-icon >fas fa-file-pdf</v-icon> 
                        </v-btn>
                </template>
                <span>Inventario de Herramientas</span>
            </v-tooltip>                                                                             
        </v-toolbar>        
        <v-data-table
            :headers="EncabezadoTablaInventarioSucursal"
            :items="ArrayInventarioHerramientaPorSucursal"
            class="elevation-1"
            :search="buscarRegistro"
            :footer-props="{itemsPerPageText: 'Filas por página'}"                 
            :loading="loading"
            loading-text="Cargando Datos..."                                
        >
            <template v-slot:item.actions="{item}">
                <v-tooltip left color="#3c8dbc">
                    <template v-slot:activator="{ on }">
                        <v-btn small class="ml-2" dark fab color="#3c8dbc" v-on="on" @click="AbrirModalRetornarHerramientasACentral(item)" v-if="permisoCrear">
                            <v-icon small>fas fa-exchange-alt</v-icon>
                        </v-btn>                        
                    </template>
                    <span class="fontButton">Retornar Herramientas a bodega</span>
                </v-tooltip>                                                                                            
            </template>        
            <template v-slot:no-results>    
                <v-alert type="warning" prominent dense outlined border="left" class="text-xs-center mx-10 mt-2 titulo">
                    Herramienta no existe
                </v-alert>                        
            </template>
            <template v-slot:no-data v-if="ArrayInventarioHerramientaPorSucursal.length === 0">
                <v-alert type="warning" prominent dense outlined border="left" class="text-xs-center mx-10 mt-2 titulo" >
                    No existen herramientas registradas
                </v-alert>
            </template>            
        </v-data-table>
        <!-- mostramos el circular progress cuando carguen los datos al mostrar -->
        <v-overlay :value="EstadoCircularProgress">
            <v-progress-circular indeterminate :size="80" :width="10" color="#ffffff"></v-progress-circular> Cargando datos...
        </v-overlay>                      
        <MensajeRetornarHerramientasCentral 
            :dialogoMensajeRetornarCentral="dialogoMensajeRetornarCentral" @CerrarModalRetornarVehiculoACentral="CerrarModalRetornarHerramientasACentral"
            :datosHerramientas="datosHerramientas" :alertError="alertError" @ObtenerInventarioHerramientaPorSucursal="ObtenerInventarioHerramientaPorSucursal"
        />
        <ControlladorExcepciones :response="responseStatus"/>
        <VisualizarPDFInventarioGeneral 
            :dialogoVisualizarPDFInventario="dialogoVisualizarPDFInventario" :Titulo="Titulo" :URLPDF="URLPDF"
            @CerrarModalVisualizarPDFInventario="CerrarModalVisualizarPDFInventario"
        />                  
    </div>
</template>

<script>
import BotonActualizarTabla from '../../../BotonActualizarTabla'
import MensajeRetornarHerramientasCentral from '../MensajeRetornarHerramientasCentral'
import ControlladorExcepciones from '../../../../components/ControlandoExcepcionesHTTPS'
import { showMessageError, showMessageSuccess } from '../../../../services/sweetAlert'
import VisualizarPDFInventarioGeneral from '../VisualizarPDFInventario'

export default {
    components:{
        BotonActualizarTabla,
        MensajeRetornarHerramientasCentral,
        ControlladorExcepciones,   
        VisualizarPDFInventarioGeneral,     
    },
    props: {
        permisoCrear: Boolean, idSucursal: Number,
        alertError: Boolean,
        tab: String,
        TituloTabla: String,
        idProyecto: Number,
        loading: Boolean,
        ArrayInventarioHerramientaPorSucursal: Array,
        ActivarMenuTabs: Boolean,
    },

    data() {
        return {
            buscarRegistro:'',
            EncabezadoTablaInventarioSucursal:[
                {text: 'Nombre', value: 'herramienta.catalogoHerramienta.nombre', sortable: false, align: 'center', divider: 'true', class: 'tituloTablaSubMenu'},                                
                {text: 'Marca', value: 'herramienta.catalogoHerramienta.marcaHerramienta.nombre', sortable: false, align: 'center', divider: 'true', class: 'tituloTablaSubMenu'},                                
                {text: 'Sucursal origen', value: 'herramienta.bodega.sucursal.nombre', sortable: false, align: 'center', divider: 'true', class: 'tituloTablaSubMenu'},
                {text: 'Bodega origen', value: 'herramienta.bodega.nombre', sortable: false, align: 'center', divider: 'true', class: 'tituloTablaSubMenu'},                                
                {text: 'Cantidad', value: 'cantidad', sortable: false, align: 'center', divider: 'true', class: 'tituloTablaSubMenu'},                                
                {text: 'Fecha ultima Transferencia', value: 'fecha_Creacion', sortable: false, align: 'center', divider: 'true', class: 'tituloTablaSubMenu'},                                
                {text: 'Acciones', value: 'actions', sortable: false, align: 'center', divider: 'true', class: 'tituloTablaSubMenu'},                                
            ],                         
            // variables para retornar vehiculo a central
            dialogoMensajeRetornarCentral: false,
            datosHerramientas: {
                TituloHerramienta:'',
                Nombre:'',
                Marca:'',
                Cantidad:'',
                idProyecto: 0,
                idHerramienta:0,                
            },
            idHerramienta:0,            
            responseStatus:[],
            //variables para visualizar pdf de inventario general
            dialogoVisualizarPDFInventario: false,
            Titulo: '',
            URLPDF: '',                   
            EstadoCircularProgress:false,                 
        }
    },

    methods: {
        ObtenerInventarioHerramientaPorSucursal(){
            this.$emit('ObtenerInventarioHerramientaPorSucursal')
        },
        AbrirModalRetornarHerramientasACentral(datosHerramientas){
            this.datosHerramientas.TituloHerramienta = "Herramienta"
            this.datosHerramientas.Nombre = datosHerramientas.herramienta.catalogoHerramienta.nombre
            this.datosHerramientas.Marca = datosHerramientas.herramienta.catalogoHerramienta.marcaHerramienta.nombre
            this.datosHerramientas.Cantidad = datosHerramientas.cantidad
            this.datosHerramientas.idProyecto = datosHerramientas.idProyecto
            this.datosHerramientas.idHerramienta = datosHerramientas.idHerramienta

            this.dialogoMensajeRetornarCentral = true
        },
        CerrarModalRetornarHerramientasACentral(){
            this.dialogoMensajeRetornarCentral = false
        },
        async AbrirModalVisualizarPDFInventario(){
            this.EstadoCircularProgress = true
            this.Titulo = "PDF de inventario de Herramientas"
            let datos = {idProyecto: this.idProyecto, idSucursal: this.idSucursal , rubro: 3}
            const response = await this.$store.dispatch('InventarioGeneralPDF', datos)
            if(response.status === 200){
                this.alertError= false
                this.loading = false       
                this.URLPDF= process.env.VUE_APP_BACKEND_HOST + '/Proyecto/pdf/'+this.idProyecto+'/rubro/'+3+'/idSucursal/'+this.idSucursal
                this.dialogoVisualizarPDFInventario = true
                this.EstadoCircularProgress = false
            }else{
                this.ControllerException(response)
                this.EstadoCircularProgress = false
            }                                        
        },
        CerrarModalVisualizarPDFInventario(){
            this.URLPDF= ''
            this.dialogoVisualizarPDFInventario = false
        },            
        // controlamos las excepciones de las peticiones al api
        ControllerException(response){
            if(typeof response === 'undefined'){
                this.alertError=true
                this.loading = false
                this.EstadoCircularProgress = false
                this.loadingEliminarTipoVehiculo = false
                return 0
            }else if(response.status === 400){
                showMessageError('Error 400','Petición mala')
                this.loadingEliminarTipoVehiculo = false
                this.loading = false
                this.EstadoCircularProgress = false
            }else if(response.status === 401){
                showMessageError('No Autorizado!','Su usuario no tiene permisos para este módulo')
                this.loadingEliminarTipoVehiculo = false
                this.loading = false
                this.EstadoCircularProgress = false
            }else if(response.status === 404){
                showMessageError('Error 404','El servidor no encontro el recurso solicitado')            
                this.loadingEliminarTipoVehiculo = false
                this.loading = false
                this.EstadoCircularProgress = false
            }else if(response.status === 500){
                showMessageError('Error 500','Error en el servidor')            
                this.loadingEliminarTipoVehiculo = false
                this.loading = false
                this.EstadoCircularProgress = false
            }
        },             
    },
}
</script>